$tablet-breakpoint: 840px;
$mobile-breakpoint: 480px;

@mixin centered-container {
  max-width: 1440px;
  padding: 0 104px;
  margin: 0 auto;

  @media only screen and (max-width: $tablet-breakpoint) {
    padding: 0 48px;
  }

  @media only screen and (max-width: $mobile-breakpoint) {
    padding: 0 16px;
  }
}

.top-level-header-container {
  padding: 0.4rem 0;
  box-shadow: 0 0.8rem 2.4rem #dcdce1;

  & > * {
    @include centered-container;
  }
}

.top-level-layout-container {
  @include centered-container;
}

.organization-menu-container {
  display: block;

  @media only screen and (max-width: $tablet-breakpoint) {
    display: none;
  }
}
